export const schema = {
  properties: {
    id: {
      type: 'string',
      title: 'ID',
      hidden: true
    },
    registrationNumber: {
      type: 'string',
      format: 'button',
      title: 'Return',
      color: 'link',
      sortable: true
    },
    reference: {
      type: 'string',
      title: 'HMRC reference',
      sortable: true
    },
    submittedOn: {
      type: 'string',
      format: 'date-time',
      title: 'Submitted on',
      sortable: true
    },
    submittedBy: {
      type: 'string',
      title: 'Submitted by',
      sortable: true
    },
    approvedOn: {
      type: 'string',
      format: 'date-time',
      title: 'Approved on',
      sortable: true
    },
    approvedBy: {
      type: 'string',
      title: 'Approved by',
      sortable: true
    },
    TaxRegistrationId: {
      type: 'string',
      title: 'tr id',
      hidden: true
    }
  }
}
